import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import { getDefaultPostLoginRoute, isRouteAccessible } from '../../config/panelMenuAccess';

/**
 * پس از تغییر سازمان فعال، اگر مسیر فعلی دیگر مجاز نباشد به اولین صفحه مجاز هدایت می‌کند.
 */
export default function OrgRouteGuard() {
  const { user, activeOrganization, organizations, orgContextKey, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !user) return;
    const ctx = { user, activeOrganization, organizations };
    if (!isRouteAccessible(location.pathname, ctx)) {
      navigate(getDefaultPostLoginRoute(ctx), { replace: true });
    }
  }, [orgContextKey, location.pathname, user, activeOrganization, organizations, loading, navigate]);

  return null;
}
